import './App.css';
import hamburger from './HamburgerMenu.svg'
import house from './House.png'
import skyline from './Skyline.png'
import vote from './Vote.jpg'
import React from 'react';

const styles = {
  postcardContainer: {
    alignItems: 'stretch',
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    marginLeft: '25%',
    marginRight: '25%'
  },
  postcardView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 20
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  voteImage: {
    height: 'auto',
    width: '80%',
    marginTop: '100px'
  },
  headline: {
    textShadow: '3px 3px 3px #ccc'
  }
}

function PostcardGallery(props) {
  return (
    <div style={styles.postcardContainer}>
      <div style={styles.postcardView}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <img src={vote} style={styles.voteImage} />
        <h1 style={styles.headline}>
          Postcard Gallery
        </h1>
        <p>Coming Soon!</p>
      </div>
    </div>
  )
}

export default PostcardGallery;
